// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'

import { simpleHttp, http } from '@/utils/http'
import App from './App'
import router from './router'
import store from '@/vuex/store'

Vue.use(BootstrapVue)
Vue.use(VeeValidate, {fieldsBagName: 'veeFields' })
Vue.use(Router)
Vue.prototype.$http = http
Vue.prototype.$simpleHttp = simpleHttp
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
